export default {
    text: ' يمكنك مراسلتنا عبر هذا النموذج وشرح هدف المراسلة وسوف يصلك الرد في اسرع وقت ممكن من فريق العمل',
    resellerText: 'اعلاء العضوية بواسطة الموزعين المعتمدين',
    message: 'الرسالة'
}
